<!-- 
    Testkomponente für das Routing
-->

<template>
    <div class="detail-card container">
        <div>child-array-widget</div>
        <div class="field">
            <div class="label">Param for Link</div>
            <div class="value">
                <QInput outlined type="textarea" v-model="newParam" :height="80" />
            </div>
        </div>
        <router-link class="router-link" :to="getPathToChildArray()">
            <QitButton label="Child-Array-Route" />
        </router-link>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { encodeParamArrayToString } from "@/shared/environment/ability-route-helper";
import QitButton from "@/shared/components/buttons/qit-button.vue";
import { QInput } from "quasar";
import { useAbilityRoute } from "@/shared/environment/ability-route";

const { getPathToChild } = useAbilityRoute();

const newParam = ref("<leer>");
function getPathToChildArray() {
    return getPathToChild("playGroundChildArray", {
        playGroundChildArray: encodeParamArrayToString(newParam.value === "" ? [] : [newParam.value]),
    });
}
</script>

<style lang="scss" scoped>
.container {
    display: flex;
    gap: $spacing-m;
    padding: $spacing-m;
}
</style>
